<template>
  <v-card tile>
    <v-card-title class="grey lighten-2">{{ title }}</v-card-title>
    <slot />
  </v-card>
</template>

<script>
export default {
  name: 'MasterdataModal',

  props: {
    title: String
  }
}
</script>
